var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.981,
    height: 14.587,
    viewBox: "0 0 20.981 14.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M17.1,9a1,1,0,0,1,0,1.42l-4.6,4.6h16.54a1,1,0,0,1,0,2H12.521l4.58,4.57A1,1,0,1,1,15.691,23l-6.36-6.36a.88.88,0,0,1,0-1.27L15.681,9A1,1,0,0,1,17.1,9Z",
    transform: "translate(-9.06 -8.704)",
    fill: "#14bef0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconBlue);
export default __webpack_public_path__ + "static/media/arrow-icon-blue.fb5f539da43c34b282880bef1c8c134b.svg";
export { ForwardRef as ReactComponent };